import { t } from '@/i18n/translator';

export const DeleteTagsCommand = (
  assetId: string,
  oldTags: Array<string>,
  oldTagIds: Array<string>,
  newTags: Array<string>,
  newTagIds: Array<string>,
  updateTagsMutation: any,
) => {
  const apply = () => updateTagsMutation({ id: assetId, body: { tags: newTags, tagIds: newTagIds }, context: 'clear' });
  const undo = () => updateTagsMutation({ id: assetId, body: { tags: oldTags, tagIds: oldTagIds } });
  const redo = () => updateTagsMutation({ id: assetId, body: { tags: newTags, tagIds: newTagIds } });

  return {
    apply,
    undo,
    redo,
    message: t('commands.deleteTags', { count: oldTags.length }),
  };
};
